import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneGlossary = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"type": "page",
			"properties": {
				"title": [
					[
						"Глоссарий"
					]
				]
			},
			"content": [
				"dff44ab8-2854-4517-af68-2c096a8073f3",
				"d1aebc94-ef57-43d4-beb8-cf07d6ea4d92",
				"a243babe-2963-4073-80ca-3c3e7c70f730",
				"ae7fca1b-8057-4ad9-b1b0-855daeb2fee5",
				"a184e7ef-45e3-4036-88d6-9213542cd1de",
				"a0f59b34-0f9d-4af5-8a01-17627c26db77",
				"bb027765-e6de-4902-8611-0ffa15a29816",
				"f0026634-b5ec-41b9-a706-a1c3784c41d6",
				"e9da3547-ceca-443d-a954-b74f52b1b48c",
				"efe92bca-2bf7-4b26-af1b-d5dcfc7809de",
				"4fdcbf90-1b76-4c6d-8cbb-8aca0c118204",
				"e1f37574-5788-473c-82f1-013e50e9d507",
				"e2e95227-c787-4424-a005-e775cf25a212",
				"e1328f75-7315-4c02-acb7-1b07b77da0fe",
				"4c9b4f66-76e5-45fa-9bf7-95f6649a9fca",
				"6c4459fd-161b-46ae-81bb-9c26a64a3d36",
				"2ea03c82-cd00-42f1-80b8-af2471467ffe",
				"e2696b11-34c0-4388-b0b8-870109ef5897",
				"8a1b47bf-784e-41f0-abc1-e794bb71f427",
				"2ed224e2-cf18-40aa-a59a-872e0353f547",
				"36837b49-486a-44f9-b53e-d1b295e80766",
				"e15fcf50-93d8-429c-b1e3-b9634b4d270e",
				"b819f860-b121-44e1-ac88-b59864123c11",
				"b7934229-1ac1-4480-a2a5-176588133f35",
				"aa0517f2-d23a-4f49-94e9-0ad5d47383ad",
				"ab54caf2-9b45-4635-b0f5-63183fed6762",
				"a3da20b9-a9d6-4bb3-9c6d-a186dd092582",
				"e06c0cdf-04ab-4852-b0cd-790a86556139",
				"c1c03bc9-7b0c-4afb-9c08-ae1fcc26593f",
				"b3ae0a41-6ed6-44b0-a7fa-e6800f36621a",
				"3e96877b-ddf8-4d23-a307-0d78776bd15c",
				"ac59e5d8-013b-4b80-8686-6a2a26829ce4",
				"a5c7fe31-8be5-4a2c-b897-4d964001a7bd",
				"fb8383a1-836b-4942-9dd7-bbd9e6aa075b",
				"79cb34ad-52fe-46c4-85c4-41805bbc09b1",
				"4aa433d4-9fa4-42ca-8326-047a4793e037",
				"7deceb00-31ab-4bcd-9497-e614c31dadb0",
				"b84df9e3-1279-4b58-bf0b-c0bdfec55dcb",
				"0b382a42-b3c7-40b2-95c2-20cb0f21af54",
				"8657965d-8ac2-4a1b-8591-8835bf15ef15",
				"4802c2b9-6e7e-44bd-b633-9d0b38a34dcd",
				"441f6c5b-0ffb-48d1-a3f5-f29fc2e9b446",
				"0fa7d2dd-16e5-40a1-9f9c-9bf283d34d3d",
				"0338648d-0c18-4886-a119-9c2920771ac6",
				"e1a42aef-241a-4926-ac36-80b6916e400c",
				"3a8a108d-2042-4ca9-ae3f-0bdb2a8c9632",
				"91f4ba84-312e-4c73-a0a7-daf8b39a530c",
				"cd2901dd-ef5f-4a9f-858b-a5dd3b6af21d",
				"194f2e10-2038-4c9e-a670-34608cb4521f",
				"0b4ea0d9-7914-4042-91f2-28c4dcae6065",
				"d28d759b-9a09-46f0-a99a-09ebbc16cc36",
				"3f2599c1-1d73-4346-9b52-a92251376654"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dff44ab8-2854-4517-af68-2c096a8073f3",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/glossary\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eee82228-305a-43ad-b48e-7daf90a49a04",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1aebc94-ef57-43d4-beb8-cf07d6ea4d92",
			"type": "text",
			"properties": {
				"title": [
					[
						"В глоссарии собрали слова и словосочетания, которые могут вызвать сомнения во время письма — и дали им значения. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8fb1d041-f336-41cc-8013-ec0e755ed288",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a243babe-2963-4073-80ca-3c3e7c70f730",
			"type": "text",
			"properties": {
				"title": [
					[
						"Единые правила помогают сохранять консистентность коммуникаций и звучать в разных каналах стройно. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "03cc5769-89bd-41a3-ad72-5740382630b1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ae7fca1b-8057-4ad9-b1b0-855daeb2fee5",
			"type": "header",
			"properties": {
				"title": [
					[
						"Названия проектов Mail"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf10830d-557c-40bf-8fb9-03053e137079",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a184e7ef-45e3-4036-88d6-9213542cd1de",
			"type": "text",
			"properties": {
				"title": [
					[
						"Название бренда: Mail — одно слово, с заглавной буквы. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a0f59b34-0f9d-4af5-8a01-17627c26db77",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0f59b34-0f9d-4af5-8a01-17627c26db77",
			"type": "text",
			"properties": {
				"title": [
					[
						"Названия продуктов: "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "74b26be4-9cc9-4a1d-942c-e287345f2b22",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bb027765-e6de-4902-8611-0ffa15a29816",
			"type": "column_list",
			"content": [
				"765fb255-f34c-4757-b123-b09cfb275c7f",
				"dd0fd559-20b0-498b-8992-216c6ceda74a"
			],
			"format": {
				"copied_from_pointer": {
					"id": "e1f37574-5788-473c-82f1-013e50e9d507",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f0026634-b5ec-41b9-a706-a1c3784c41d6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Окончание Mail можно опускать, если однозначно понятно, что речь именно о продуктах Mail. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "19cd124d-517e-406d-8bcd-c37a03f7c887",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9da3547-ceca-443d-a954-b74f52b1b48c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/bbfd474e-3780-49b6-ae31-a02635d705f8/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/bbfd474e-3780-49b6-ae31-a02635d705f8/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"copied_from_pointer": {
					"id": "352cbd8f-75f1-4df1-a883-b9ee58be52fa",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				},
				"block_preserve_scale": true
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"file_ids": [
				"bbfd474e-3780-49b6-ae31-a02635d705f8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e9da3547-ceca-443d-a954-b74f52b1b48c.png"
		},
		{
			"id": "efe92bca-2bf7-4b26-af1b-d5dcfc7809de",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Облако найдёт фотографии из путешествия"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a298c28b-237b-4d59-ada4-b04aa9d91c80",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4fdcbf90-1b76-4c6d-8cbb-8aca0c118204",
			"type": "text",
			"properties": {
				"title": [
					[
						"Название склоняется по правилам русского языка. Если при склонении возникают ложные смыслы, стоит добавить родовое слово — «сервис», «проект», «сайт» и так далее."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6e893b50-b9e9-4345-b227-7f6dd9ea73c7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e1f37574-5788-473c-82f1-013e50e9d507",
			"type": "column_list",
			"content": [
				"3d26f37c-2fc8-4194-9b12-295725b12d21",
				"db6c6cd8-6080-42ee-b9af-293f76de0966"
			],
			"format": {
				"copied_from_pointer": {
					"id": "39e55379-b2c4-41a0-84f8-5093dbb8de58",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e2e95227-c787-4424-a005-e775cf25a212",
			"type": "header",
			"properties": {
				"title": [
					[
						"Аккаунт vs ящик"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ad2840d8-7671-4d12-8b79-9689c0f7e642",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e1328f75-7315-4c02-acb7-1b07b77da0fe",
			"type": "text",
			"properties": {
				"title": [
					[
						"Mail — не только почта, это экосистема разных продуктивити-сервисов. Аккаунт больше и шире почты. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b5b460e0-9075-43c1-8c34-3299c73436c1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4c9b4f66-76e5-45fa-9bf7-95f6649a9fca",
			"type": "text",
			"properties": {
				"title": [
					[
						"Аккаунт — это как паспорт пользователя в сервисах. Он единый для Почты, Облака, Заметок, Календаря. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b5e5f897-3fa4-4354-b15f-afa4d91a3e03",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6c4459fd-161b-46ae-81bb-9c26a64a3d36",
			"type": "text",
			"properties": {
				"title": [
					[
						"Войти в аккаунт Mail можно с помощью чего угодно — в том числе почты, аккаунта \nв другом сервисе (VK ID, Госуслуги), номера телефона. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1804d432-88f2-4953-bca3-7f31540b2e58",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2ea03c82-cd00-42f1-80b8-af2471467ffe",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/56d6b63b-862e-481a-80f7-5c00dff4980f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/56d6b63b-862e-481a-80f7-5c00dff4980f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"file_ids": [
				"56d6b63b-862e-481a-80f7-5c00dff4980f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2ea03c82-cd00-42f1-80b8-af2471467ffe.png"
		},
		{
			"id": "e2696b11-34c0-4388-b0b8-870109ef5897",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Аккаунт",
						[
							[
								"b"
							]
						]
					],
					[
						" \nИспользуем, когда:\n– речь идёт о всех сервисах Mail\n– говорим о безопасности аккаунта или доступе\n– пишем об авторизации или создании аккаунта\n\n"
					],
					[
						"Пример\n",
						[
							[
								"b"
							]
						]
					],
					[
						"– Зайдите в настройки, чтобы изменить имя в "
					],
					[
						"аккаунте\n",
						[
							[
								"b"
							]
						]
					],
					[
						"– Защитите доступ к вашему "
					],
					[
						"аккаунту ",
						[
							[
								"b"
							]
						]
					],
					[
						"— включите двухфакторную аутентификацию"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "17820d71-d49b-4269-8269-8ffdefd2be97",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a1b47bf-784e-41f0-abc1-e794bb71f427",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ffbebe0f-28c0-4fd7-85a7-ab13a1dc2e25/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ffbebe0f-28c0-4fd7-85a7-ab13a1dc2e25/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"file_ids": [
				"ffbebe0f-28c0-4fd7-85a7-ab13a1dc2e25"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8a1b47bf-784e-41f0-abc1-e794bb71f427.png"
		},
		{
			"id": "2ed224e2-cf18-40aa-a59a-872e0353f547",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ящик / почта ",
						[
							[
								"b"
							]
						]
					],
					[
						"со строчной",
						[
							[
								"i"
							]
						]
					],
					[
						" \n\nИспользуем, когда: \n– пишем о состоянии ящика\n– пишем о почте как о письмах\n\n"
					],
					[
						"Пример",
						[
							[
								"b"
							]
						]
					],
					[
						"\n– "
					],
					[
						"Ящик",
						[
							[
								"b"
							]
						]
					],
					[
						" пуст\n– В "
					],
					[
						"почте",
						[
							[
								"b"
							]
						]
					],
					[
						" много непрочитанных писем\n– Проверять "
					],
					[
						"почту ",
						[
							[
								"b"
							]
						]
					],
					[
						"(т.е. письма) ",
						[
							[
								"i"
							]
						]
					],
					[
						"ещё удобнее \nс быстрой сортировкой"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "e0c762f2-7f85-44a9-9c45-2fe81117f6fe",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36837b49-486a-44f9-b53e-d1b295e80766",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/682376a7-e575-4053-b09a-139212189533/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/682376a7-e575-4053-b09a-139212189533/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.004120879120879121,
				"block_preserve_scale": true
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"file_ids": [
				"682376a7-e575-4053-b09a-139212189533"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/36837b49-486a-44f9-b53e-d1b295e80766.png"
		},
		{
			"id": "e15fcf50-93d8-429c-b1e3-b9634b4d270e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Почта ",
						[
							[
								"b"
							]
						]
					],
					[
						"с заглавной ",
						[
							[
								"i"
							]
						]
					],
					[
						"/ Почта Mail",
						[
							[
								"b"
							]
						]
					],
					[
						"\n\nИспользуем, когда: \n– говорим про Почту как про продукт \n\n"
					],
					[
						"Пример",
						[
							[
								"b"
							]
						]
					],
					[
						"\n– "
					],
					[
						"Почта",
						[
							[
								"b"
							]
						]
					],
					[
						" помечает письма зелёным щитом"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ec9c8584-ecb1-4825-b923-c2cfa3663c47",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b819f860-b121-44e1-ac88-b59864123c11",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Исключения",
						[
							[
								"b"
							]
						]
					],
					[
						" \nНа экранах Главной оставляем кнопки «Создать почту», «Добавить ящик», так как тесты показали, что с такими кнопками пользователи лучше справляются с созданием почты / аккаунта.\n\nПоддержка в ответах про восстановление доступа продолжает использовать слово почта, так как чаще всего пользователи хотят получить доступ именно к ящику.   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c7f2662a-574b-4bb6-8141-c40240320a7c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7934229-1ac1-4480-a2a5-176588133f35",
			"type": "header",
			"properties": {
				"title": [
					[
						"Спорные слова "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a45b6001-b39a-4fee-81c7-3a63b35f5d57",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa0517f2-d23a-4f49-94e9-0ad5d47383ad",
			"type": "column_list",
			"content": [
				"54f56a4e-60ab-4def-9c3b-283b5d3a27bd",
				"69e160ef-45e5-4917-94fa-7225a9ee68e1",
				"466a609a-67dc-4bcf-8b25-5cfbb343b33f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "fab3f035-2282-4405-a263-1ff15177fad4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab54caf2-9b45-4635-b0f5-63183fed6762",
			"type": "column_list",
			"content": [
				"854caca2-d8fa-40a1-9200-eb7da592789c",
				"1c563918-a226-46e4-a13a-9bf27c3fe142",
				"b1b4d1fc-fd09-4bbf-b3f6-a26106cea08e"
			],
			"format": {
				"copied_from_pointer": {
					"id": "fb29b412-ff53-48ab-b187-29c3000add47",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a3da20b9-a9d6-4bb3-9c6d-a186dd092582",
			"type": "column_list",
			"content": [
				"ffd319b0-ab98-48d0-a99b-4b2834a4b7ac",
				"8a6bd369-8586-48e3-b68b-ea7a48506815",
				"acd64916-bc82-4a57-8d88-94fec178cac8"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9e2f58a6-db5e-4c5f-8806-b836ab7997fb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e06c0cdf-04ab-4852-b0cd-790a86556139",
			"type": "column_list",
			"content": [
				"b5a87fcc-107e-4022-bd03-2aba56cc28b9",
				"f14cf1e8-1025-49f1-9dfd-9ae63f2271e6",
				"0af4a18c-22d5-4af2-97fd-e9612ebdf004"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2fcdc4b3-e213-4c3b-8e1c-8c3af5c5e33d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c1c03bc9-7b0c-4afb-9c08-ae1fcc26593f",
			"type": "column_list",
			"content": [
				"9f9c8d06-f4c2-4313-9d00-ab1f00533f0d",
				"a45a058a-3b21-4205-8ebb-2fda14ff107d",
				"336c0802-abd7-4db6-8997-3317c8465b31"
			],
			"format": {
				"copied_from_pointer": {
					"id": "b20304e3-014b-471c-aaa6-b00fc5376e21",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3ae0a41-6ed6-44b0-a7fa-e6800f36621a",
			"type": "column_list",
			"content": [
				"a8efa6c1-6dff-42c1-ac70-78116fe529dd",
				"692554ae-b22e-4e4b-b5f0-1d0bc5427c26",
				"89a51e6e-4195-46b7-8940-b554922282f3"
			],
			"format": {
				"copied_from_pointer": {
					"id": "0ba28bb3-a253-47b1-96f1-afeb8b179cdf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3e96877b-ddf8-4d23-a307-0d78776bd15c",
			"type": "column_list",
			"content": [
				"5ca263ab-48d8-4eb3-9d16-85e434dd9b91",
				"fb47c8dd-b6e5-48a9-8811-4ca8cbf142af",
				"d770453e-83fa-4ef7-821f-7880f0280421"
			],
			"format": {
				"copied_from_pointer": {
					"id": "aadf105c-88aa-4819-afe5-414d0f8f0c95",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ac59e5d8-013b-4b80-8686-6a2a26829ce4",
			"type": "column_list",
			"content": [
				"81dd0483-a42b-45d5-9247-8b5ea1e0c0ee",
				"0b706069-96ee-4c02-b0f9-fa430ae20a31",
				"ed365341-0e50-410a-959e-5aa53279b098"
			],
			"format": {
				"copied_from_pointer": {
					"id": "7ea676a6-031a-4ce4-9332-bcb01e0331c4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a5c7fe31-8be5-4a2c-b897-4d964001a7bd",
			"type": "column_list",
			"content": [
				"4ad0f60b-df1e-4ba4-82b7-8e6b4d422553",
				"75bf9ed3-08a5-4d18-9638-0f1a351081f1",
				"6af05e46-3107-4fcb-b84f-4e2ee0cde77f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "19337c1b-7c60-4165-bcf8-ec4c12530da3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb8383a1-836b-4942-9dd7-bbd9e6aa075b",
			"type": "column_list",
			"content": [
				"47f57646-731f-4dfc-bdc5-622276ade2aa",
				"3afa04c9-cc92-4934-9fef-4e2325762cf5",
				"246831ee-9759-4684-b4c3-ddb332cf500a"
			],
			"format": {
				"copied_from_pointer": {
					"id": "5251777e-94e3-49d8-9f6a-291329a9148e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "79cb34ad-52fe-46c4-85c4-41805bbc09b1",
			"type": "column_list",
			"content": [
				"32226d15-0251-4369-99f0-4ef566a5bbaf",
				"bbc3f4cd-5235-4dd0-8338-94af30251d2d",
				"c8efdfdf-67b7-4b8b-a7f5-5b8c27946a70"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9540aa0c-f242-4490-a532-ee3501d44e6f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4aa433d4-9fa4-42ca-8326-047a4793e037",
			"type": "column_list",
			"content": [
				"e8475dea-4452-4d07-909a-ba816d5ffff1",
				"a0c5935f-25f2-446d-ba01-3b484ce1b9cf",
				"659aae5b-c572-4840-81ec-d541a3de0ac3"
			],
			"format": {
				"copied_from_pointer": {
					"id": "56572357-1934-4081-b925-b3f1fadb5b84",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7deceb00-31ab-4bcd-9497-e614c31dadb0",
			"type": "column_list",
			"content": [
				"a6d2defb-9132-408f-937e-e97763e3ebdd",
				"0ab2f1ab-63da-43b7-b92f-ab615cb231aa",
				"52beddca-878e-4f5b-a0fe-adc1b71b8e7b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "9dd6259c-1c28-47b6-a82a-be64f00fe986",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b84df9e3-1279-4b58-bf0b-c0bdfec55dcb",
			"type": "column_list",
			"content": [
				"18444cd6-afe8-4430-ac38-dc782cfe9255",
				"7498cf2e-07c3-4214-81a1-675120bc6042",
				"a5c76adc-44e3-457a-8718-27d769b41e7d"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a674da51-5d14-41a5-9c6c-8d61bd00a6ba",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0b382a42-b3c7-40b2-95c2-20cb0f21af54",
			"type": "column_list",
			"content": [
				"6cae3bb6-3562-4088-8823-41d1caea57c4",
				"b6de80ad-3ea0-4132-80a4-e7e8c11c89db",
				"819f879e-1c9f-4e19-8cc6-a112b3712a00"
			],
			"format": {
				"copied_from_pointer": {
					"id": "dafa4ccb-6caa-4aa4-8162-a92c8f2c6e92",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8657965d-8ac2-4a1b-8591-8835bf15ef15",
			"type": "column_list",
			"content": [
				"2ddf0398-40f0-4d8b-a02e-45441d625f0b",
				"a6cfd558-98f2-422f-a759-781d026a135c",
				"24de6356-9c48-4bf8-b721-1e07aa87fd3c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "19d45e53-0c6d-4267-b76a-131d26ad98f1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4802c2b9-6e7e-44bd-b633-9d0b38a34dcd",
			"type": "column_list",
			"content": [
				"854d838e-aeaf-4489-938c-192cf7cd6b69",
				"fa3d30b6-88e5-4430-a162-6137d54960b1",
				"bd4945e4-638b-4eab-8e3d-54e7d54054f9"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ff963d54-296a-4f3d-b40b-e07fac0fcada",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "441f6c5b-0ffb-48d1-a3f5-f29fc2e9b446",
			"type": "column_list",
			"content": [
				"890ed4b1-52cd-42e4-870c-08f87f28daa1",
				"0e477402-4c49-417c-b9f4-2512a2b7a277",
				"8a32cd4d-32c8-4c52-8256-ffc0b4d18a4f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "705c117a-072c-48f6-82f8-6202e66ad0d2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fa7d2dd-16e5-40a1-9f9c-9bf283d34d3d",
			"type": "column_list",
			"content": [
				"7579c963-b4c9-466b-8135-4290dd0faf29",
				"89c48907-45cf-48d9-b967-ce08b5c538ce",
				"0152a23f-ca0f-4ceb-8821-a027f47de299"
			],
			"format": {
				"copied_from_pointer": {
					"id": "36c5121b-7064-41d6-b3d6-ace39f100e41",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0338648d-0c18-4886-a119-9c2920771ac6",
			"type": "column_list",
			"content": [
				"9f293570-631f-4961-852a-9a41af601519",
				"1eb2cb9a-fb5a-46af-ab89-67f6b56a77af",
				"b9371174-da35-448f-9b50-fdfd4496fca5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ae3bdffe-b5bb-40ec-8fbb-8b24e5e11c30",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e1a42aef-241a-4926-ac36-80b6916e400c",
			"type": "column_list",
			"content": [
				"9fbe86a2-917f-4230-9898-faf6e5d24e4e",
				"53ca77ec-7b56-48ec-b28a-e345ccc45729",
				"01398d3c-f1cd-4b83-9ac3-2da4da029e0c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8db8059b-eaa3-4269-84c7-ef5330183f5d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3a8a108d-2042-4ca9-ae3f-0bdb2a8c9632",
			"type": "column_list",
			"content": [
				"847ea0b3-ce94-4d38-888f-2f45736dbae2",
				"cad8f0da-2c36-4142-84c0-1b73d01bdf2a",
				"1a83b137-76b6-4aea-a473-397f34446b03"
			],
			"format": {
				"copied_from_pointer": {
					"id": "564cb00d-5dae-4aeb-9cb0-bc3527b5cb1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91f4ba84-312e-4c73-a0a7-daf8b39a530c",
			"type": "column_list",
			"content": [
				"940b38d1-6e28-47ba-8c49-303f4786f81a",
				"a3a472e9-2415-4c35-ab23-1896b97e0076",
				"32922db6-17b7-446c-bb66-6fb205afd011"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a2919a04-cdf3-42d5-a384-554272b77852",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cd2901dd-ef5f-4a9f-858b-a5dd3b6af21d",
			"type": "column_list",
			"content": [
				"91711d1c-bc38-4260-86f4-c6d432d1d994",
				"4834414c-9342-4c95-b20d-cc36fea0a98b",
				"1de7394c-0b94-41cb-b209-6476cdd4dfcf"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2d1d5d55-17d3-4b39-ba83-5de2cc6187ed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "194f2e10-2038-4c9e-a670-34608cb4521f",
			"type": "column_list",
			"content": [
				"ca61e0c3-0003-465f-ae02-3b0b8e02850c",
				"b8158a7f-d864-4bf2-8746-4bcb494e85e5",
				"2cd31ab5-c44c-4909-9e37-c8a4e0848650"
			],
			"format": {
				"copied_from_pointer": {
					"id": "397d1490-15f7-4e30-8357-dfd49d5843dc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0b4ea0d9-7914-4042-91f2-28c4dcae6065",
			"type": "column_list",
			"content": [
				"1c6dc1b0-9985-4909-9b7b-4f37a9edc126",
				"9e87e868-d5de-4d86-bd5e-3f20c242238f",
				"ecf0c966-3848-4f5a-801b-2e0876c8de6c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "7420cbbb-b58f-4c44-b375-c32e6cad9439",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d28d759b-9a09-46f0-a99a-09ebbc16cc36",
			"type": "column_list",
			"content": [
				"b4a0a141-5b43-4308-8526-4338ea4322fd",
				"ab74831f-73f2-48a8-a423-6d7a8bcccc84",
				"9547280c-f60c-4188-8437-b005f78aaff0"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8817d135-edd6-4987-8512-4442f105932b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3f2599c1-1d73-4346-9b52-a92251376654",
			"type": "column_list",
			"content": [
				"d67186ce-3fa0-4c06-95f9-f42717da022e",
				"03c341e4-d1de-472c-9d0c-c36447b73faf",
				"498dd8c2-f0a6-4649-aa2e-dabefa06ac0d"
			],
			"format": {
				"copied_from_pointer": {
					"id": "db8dea72-6cff-4b89-8695-c375c2cbddc5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cb2b1b2c-b795-4abf-b11f-772b33e43908",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "765fb255-f34c-4757-b123-b09cfb275c7f",
			"type": "column",
			"content": [
				"ab7bac89-5ae8-4acb-b116-5d35b49ab6a3",
				"9f2ed382-1c6a-4bc4-a1aa-cc22dad0bdc8"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "3d26f37c-2fc8-4194-9b12-295725b12d21",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "bb027765-e6de-4902-8611-0ffa15a29816",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd0fd559-20b0-498b-8992-216c6ceda74a",
			"type": "column",
			"content": [
				"213e5458-867d-4bc8-a93b-99ad9638b895",
				"6d536e5e-9daa-41b8-8ae3-68c86e4e3fed"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "db6c6cd8-6080-42ee-b9af-293f76de0966",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "bb027765-e6de-4902-8611-0ffa15a29816",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab7bac89-5ae8-4acb-b116-5d35b49ab6a3",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/aa9251fc-938c-45cc-b486-aacae640120e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/aa9251fc-938c-45cc-b486-aacae640120e/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"copied_from_pointer": {
					"id": "53dd4e01-9c64-4a2f-b3ae-e85ec818060c",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				},
				"block_preserve_scale": true
			},
			"parent_id": "765fb255-f34c-4757-b123-b09cfb275c7f",
			"parent_table": "block",
			"file_ids": [
				"aa9251fc-938c-45cc-b486-aacae640120e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ab7bac89-5ae8-4acb-b116-5d35b49ab6a3.png"
		},
		{
			"id": "9f2ed382-1c6a-4bc4-a1aa-cc22dad0bdc8",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Сервисы Mail\nПочта Mail\nОблако Mail\nКалендарь Mail\nЗаметки Mail "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a3982e62-37b4-401a-9ae3-153f44ac0363",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "765fb255-f34c-4757-b123-b09cfb275c7f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "213e5458-867d-4bc8-a93b-99ad9638b895",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b259ce17-1729-4ac0-a8db-54a6b911a1b2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b259ce17-1729-4ac0-a8db-54a6b911a1b2/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"copied_from_pointer": {
					"id": "fca0b4a8-f641-4fc4-a3fb-da2b189e9717",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				},
				"block_preserve_scale": true
			},
			"parent_id": "dd0fd559-20b0-498b-8992-216c6ceda74a",
			"parent_table": "block",
			"file_ids": [
				"b259ce17-1729-4ac0-a8db-54a6b911a1b2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/213e5458-867d-4bc8-a93b-99ad9638b895.png"
		},
		{
			"id": "6d536e5e-9daa-41b8-8ae3-68c86e4e3fed",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Сервисы от/в Mail\nПочта от/в Mail\nОблако от/в Mail\nКалендарь от/в Mail\nЗаметки от/в Mail "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "48775cbc-589f-402e-8cb9-755aa9d89010",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "dd0fd559-20b0-498b-8992-216c6ceda74a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d26f37c-2fc8-4194-9b12-295725b12d21",
			"type": "column",
			"content": [
				"53dd4e01-9c64-4a2f-b3ae-e85ec818060c",
				"a3982e62-37b4-401a-9ae3-153f44ac0363"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "638ed801-066f-4fa8-a054-70d919660b1a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e1f37574-5788-473c-82f1-013e50e9d507",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "db6c6cd8-6080-42ee-b9af-293f76de0966",
			"type": "column",
			"content": [
				"fca0b4a8-f641-4fc4-a3fb-da2b189e9717",
				"48775cbc-589f-402e-8cb9-755aa9d89010"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "07ff80d2-41fa-4e24-9432-1b004a249878",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e1f37574-5788-473c-82f1-013e50e9d507",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "53dd4e01-9c64-4a2f-b3ae-e85ec818060c",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/aa9251fc-938c-45cc-b486-aacae640120e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/aa9251fc-938c-45cc-b486-aacae640120e/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "3d26f37c-2fc8-4194-9b12-295725b12d21",
			"parent_table": "block",
			"file_ids": [
				"aa9251fc-938c-45cc-b486-aacae640120e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/53dd4e01-9c64-4a2f-b3ae-e85ec818060c.png"
		},
		{
			"id": "a3982e62-37b4-401a-9ae3-153f44ac0363",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Издание Дети Mail подготовило обзор...\n\nВ Облаке Mail можно хранить фото"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6b674d21-d24d-466a-9813-c0c4b32968cc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3d26f37c-2fc8-4194-9b12-295725b12d21",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fca0b4a8-f641-4fc4-a3fb-da2b189e9717",
			"type": "image",
			"properties": {
				"size": [
					[
						"0.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b259ce17-1729-4ac0-a8db-54a6b911a1b2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"block_height": 6,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b259ce17-1729-4ac0-a8db-54a6b911a1b2/Untitled.png",
				"block_full_width": false,
				"block_page_width": false,
				"block_aspect_ratio": 0.00872093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "db6c6cd8-6080-42ee-b9af-293f76de0966",
			"parent_table": "block",
			"file_ids": [
				"b259ce17-1729-4ac0-a8db-54a6b911a1b2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fca0b4a8-f641-4fc4-a3fb-da2b189e9717.png"
		},
		{
			"id": "48775cbc-589f-402e-8cb9-755aa9d89010",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Дети Mail подготовили обзор "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9b444456-701f-4595-a2af-63c0aa7f6657",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "db6c6cd8-6080-42ee-b9af-293f76de0966",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "54f56a4e-60ab-4def-9c3b-283b5d3a27bd",
			"type": "column",
			"content": [
				"de8a7cb5-b921-4946-be58-494080d45a44"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "4e74d0f8-d5b3-431a-b07a-3f8755b4587b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aa0517f2-d23a-4f49-94e9-0ad5d47383ad",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69e160ef-45e5-4917-94fa-7225a9ee68e1",
			"type": "column",
			"content": [
				"84ad5525-1d55-4b02-9e9a-3398841170ed"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "b86734d8-10b5-4b52-a575-d7d3e2527c82",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aa0517f2-d23a-4f49-94e9-0ad5d47383ad",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "466a609a-67dc-4bcf-8b25-5cfbb343b33f",
			"type": "column",
			"content": [
				"59f1a5b6-653c-44f6-93c6-37909bb17ecd"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "ef8d7593-ad7b-4fd5-9b6f-1cc959f80158",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "aa0517f2-d23a-4f49-94e9-0ad5d47383ad",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de8a7cb5-b921-4946-be58-494080d45a44",
			"type": "text",
			"properties": {
				"title": [
					[
						"Слово (а-я, a-z)",
						[
							[
								"b"
							],
							[
								"h",
								"default"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ad5e06b7-830b-4f96-8a83-546279094a1d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "54f56a4e-60ab-4def-9c3b-283b5d3a27bd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "84ad5525-1d55-4b02-9e9a-3398841170ed",
			"type": "text",
			"properties": {
				"title": [
					[
						"Правило",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "3674a7fc-37fd-4223-b796-a00604c5a11f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "69e160ef-45e5-4917-94fa-7225a9ee68e1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "59f1a5b6-653c-44f6-93c6-37909bb17ecd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пример ",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "cdf929de-2e04-44d1-adf9-4074b80315a6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "466a609a-67dc-4bcf-8b25-5cfbb343b33f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "854caca2-d8fa-40a1-9200-eb7da592789c",
			"type": "column",
			"content": [
				"a125cd64-b242-4d6c-936e-53e6aac8c9a0"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "14c417ed-1889-4215-a299-00bf126b8f13",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ab54caf2-9b45-4635-b0f5-63183fed6762",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1c563918-a226-46e4-a13a-9bf27c3fe142",
			"type": "column",
			"content": [
				"7c6582d8-e879-4548-8e5b-4193b01d4dec"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "fd3f8add-c978-4994-af3a-e0e45c5848d4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ab54caf2-9b45-4635-b0f5-63183fed6762",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1b4d1fc-fd09-4bbf-b3f6-a26106cea08e",
			"type": "column",
			"content": [
				"b1b43f00-10bc-4d7e-b14f-ef4dba86adfa"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "ccba335f-886b-48ce-87a7-818bcfea57b8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ab54caf2-9b45-4635-b0f5-63183fed6762",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a125cd64-b242-4d6c-936e-53e6aac8c9a0",
			"type": "text",
			"properties": {
				"title": [
					[
						"авторизация "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "b6dab387-cc5d-43d2-872c-c18ca4415887",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "854caca2-d8fa-40a1-9200-eb7da592789c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c6582d8-e879-4548-8e5b-4193b01d4dec",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, имеет глагольные формы  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "5a4fff49-7820-4ab9-aae3-5096b02d5949",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1c563918-a226-46e4-a13a-9bf27c3fe142",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1b43f00-10bc-4d7e-b14f-ef4dba86adfa",
			"type": "text",
			"properties": {
				"title": [
					[
						"Авторизуйтесь  \nв Почте "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "d2a66173-6868-4d69-87c1-ff56b1e64bad",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b1b4d1fc-fd09-4bbf-b3f6-a26106cea08e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ffd319b0-ab98-48d0-a99b-4b2834a4b7ac",
			"type": "column",
			"content": [
				"e997f608-2906-45ed-8c92-de22878b5c69"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "37ae809d-f82b-4653-9f62-848bcafd3ea8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a3da20b9-a9d6-4bb3-9c6d-a186dd092582",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a6bd369-8586-48e3-b68b-ea7a48506815",
			"type": "column",
			"content": [
				"f9d6065d-60e9-4b1d-a5bf-26c5498c1a6e"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "6f1da454-fd8d-4056-af6a-1e561c4a568e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a3da20b9-a9d6-4bb3-9c6d-a186dd092582",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "acd64916-bc82-4a57-8d88-94fec178cac8",
			"type": "column",
			"content": [
				"8b18c42a-6683-43be-ab3f-147f88b7c99c"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "dfd8bd76-4bee-4210-8623-f08329b774b6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a3da20b9-a9d6-4bb3-9c6d-a186dd092582",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e997f608-2906-45ed-8c92-de22878b5c69",
			"type": "text",
			"properties": {
				"title": [
					[
						"анонимайзер "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "b200e2d8-3890-4a59-89ad-c85d5051325c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ffd319b0-ab98-48d0-a99b-4b2834a4b7ac",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9d6065d-60e9-4b1d-a5bf-26c5498c1a6e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, не имеет глагольных форм  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "ee18d2c0-9b9c-49c3-b24f-50febedc3a89",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8a6bd369-8586-48e3-b68b-ea7a48506815",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8b18c42a-6683-43be-ab3f-147f88b7c99c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Настройте анонимайзер и создайте анонимный адрес для вашей почты"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "fc4f046e-17bc-4440-9b89-43dc1020c9c0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "acd64916-bc82-4a57-8d88-94fec178cac8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5a87fcc-107e-4022-bd03-2aba56cc28b9",
			"type": "column",
			"content": [
				"10451772-c546-4800-96aa-d1e76ca0b042"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "9e94de24-0461-42ba-9365-91537d1c792f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e06c0cdf-04ab-4852-b0cd-790a86556139",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f14cf1e8-1025-49f1-9dfd-9ae63f2271e6",
			"type": "column",
			"content": [
				"6315e1e3-6a23-4e2d-85bf-accedc2dcc92",
				"b5342bb0-0c36-4ccc-9c07-39c2482b21ee"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "a0eb7808-677d-4798-9b5a-87736d1c02c1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e06c0cdf-04ab-4852-b0cd-790a86556139",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0af4a18c-22d5-4af2-97fd-e9612ebdf004",
			"type": "column",
			"content": [
				"d970ea7d-8350-475d-930c-5eec3d3d1e54"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "384f7762-9ede-49d7-afe8-dfb346898b77",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e06c0cdf-04ab-4852-b0cd-790a86556139",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "10451772-c546-4800-96aa-d1e76ca0b042",
			"type": "text",
			"properties": {
				"title": [
					[
						"антиспам "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "608550e4-6f6b-4064-9ed8-a227ea5630ab",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b5a87fcc-107e-4022-bd03-2aba56cc28b9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6315e1e3-6a23-4e2d-85bf-accedc2dcc92",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, \nсиноним — спам-фильтр  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "2df26e30-048a-4e5d-a474-8fc319800634",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "f14cf1e8-1025-49f1-9dfd-9ae63f2271e6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5342bb0-0c36-4ccc-9c07-39c2482b21ee",
			"type": "text",
			"parent_id": "f14cf1e8-1025-49f1-9dfd-9ae63f2271e6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d970ea7d-8350-475d-930c-5eec3d3d1e54",
			"type": "text",
			"properties": {
				"title": [
					[
						"Антиспам защищает почтовые ящики \nот спама "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "81e4493c-d32e-4e26-877d-45bdc479ca2f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0af4a18c-22d5-4af2-97fd-e9612ebdf004",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f9c8d06-f4c2-4313-9d00-ab1f00533f0d",
			"type": "column",
			"content": [
				"8f28ab74-74bd-4099-86db-e041ef6992e0"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "458d269b-0620-43ef-bf13-49632aef792b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c1c03bc9-7b0c-4afb-9c08-ae1fcc26593f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a45a058a-3b21-4205-8ebb-2fda14ff107d",
			"type": "column",
			"content": [
				"13b14cfb-73ec-420d-b77e-d3158e475437"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "a9a600d8-a0d2-4830-adf0-070e45a378a1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c1c03bc9-7b0c-4afb-9c08-ae1fcc26593f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "336c0802-abd7-4db6-8997-3317c8465b31",
			"type": "column",
			"content": [
				"e5004a1d-52d0-40ab-b23a-03bfa9d88e44"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "2d7c1a92-e5bb-475d-83f5-5adf6f458cd0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c1c03bc9-7b0c-4afb-9c08-ae1fcc26593f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8f28ab74-74bd-4099-86db-e041ef6992e0",
			"type": "text",
			"properties": {
				"title": [
					[
						"демоверсия  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "7c350738-11ad-41a9-9d21-621848ab7d76",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9f9c8d06-f4c2-4313-9d00-ab1f00533f0d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "13b14cfb-73ec-420d-b77e-d3158e475437",
			"type": "text",
			"properties": {
				"title": [
					[
						"Слитно "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "bff5062e-55c3-44bb-b293-50ca4a22bc3a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a45a058a-3b21-4205-8ebb-2fda14ff107d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e5004a1d-52d0-40ab-b23a-03bfa9d88e44",
			"type": "text",
			"properties": {
				"title": [
					[
						"Установите демоверсию\nприложения  "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "3d048831-e920-49bd-9026-d05cbcaf2027",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "336c0802-abd7-4db6-8997-3317c8465b31",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a8efa6c1-6dff-42c1-ac70-78116fe529dd",
			"type": "column",
			"content": [
				"16b61cce-3124-4bfd-b3e9-d6f6eac64a17"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "245f3557-e5b7-49cd-a70b-918193b5e4df",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b3ae0a41-6ed6-44b0-a7fa-e6800f36621a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "692554ae-b22e-4e4b-b5f0-1d0bc5427c26",
			"type": "column",
			"content": [
				"f54e68e7-f0f2-47c8-b9d4-4d504b1a4cc0"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "7289bd32-420a-4728-a8eb-4bafd08c43fd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b3ae0a41-6ed6-44b0-a7fa-e6800f36621a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "89a51e6e-4195-46b7-8940-b554922282f3",
			"type": "column",
			"content": [
				"79b86a63-3f29-4968-850a-460bd69ce5ee"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "f4c159d5-76cc-48f1-9588-597861eed854",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b3ae0a41-6ed6-44b0-a7fa-e6800f36621a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "16b61cce-3124-4bfd-b3e9-d6f6eac64a17",
			"type": "text",
			"properties": {
				"title": [
					[
						"двухфакторная аутентификация  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "3e57b123-5a28-4594-bd7e-8d738a323249",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a8efa6c1-6dff-42c1-ac70-78116fe529dd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f54e68e7-f0f2-47c8-b9d4-4d504b1a4cc0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сочетание склоняется, не сокращаем   "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "ef4880d0-4cc7-48a1-a87e-42ff5d042955",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "692554ae-b22e-4e4b-b5f0-1d0bc5427c26",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "79b86a63-3f29-4968-850a-460bd69ce5ee",
			"type": "text",
			"properties": {
				"title": [
					[
						"Включите двухфакторную аутентификацию "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "9f0be921-3417-4fa2-b55c-7a16aae43184",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "89a51e6e-4195-46b7-8940-b554922282f3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ca263ab-48d8-4eb3-9d16-85e434dd9b91",
			"type": "column",
			"content": [
				"df422aab-788b-4081-b29f-cfe2dbb95f2e"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "3e480178-d3a5-4900-aab8-1863035bbb82",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3e96877b-ddf8-4d23-a307-0d78776bd15c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb47c8dd-b6e5-48a9-8811-4ca8cbf142af",
			"type": "column",
			"content": [
				"ad051754-208b-4154-ad4a-e1b1eb5c5bbf"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "e5d181b0-0f57-459e-9f2d-926f8194499d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3e96877b-ddf8-4d23-a307-0d78776bd15c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d770453e-83fa-4ef7-821f-7880f0280421",
			"type": "column",
			"content": [
				"3246630d-2cde-4fa5-adb5-57d30199de3b"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "aeab7e8f-4027-4f20-a913-d306af628375",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3e96877b-ddf8-4d23-a307-0d78776bd15c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "df422aab-788b-4081-b29f-cfe2dbb95f2e",
			"type": "text",
			"properties": {
				"title": [
					[
						"инкогнито   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "675b3276-aad4-4a88-8279-ce3a12f7caf5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "5ca263ab-48d8-4eb3-9d16-85e434dd9b91",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad051754-208b-4154-ad4a-e1b1eb5c5bbf",
			"type": "text",
			"properties": {
				"title": [
					[
						"В середине предложения\nсо строчной «и»,\nбез кавычек   "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "7b2a5281-79c2-42c1-b3b5-78efde9fac62",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fb47c8dd-b6e5-48a9-8811-4ca8cbf142af",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3246630d-2cde-4fa5-adb5-57d30199de3b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Войти в режиме инкогнито "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "9682c98c-8d0b-45d0-8283-5828b9ce583c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d770453e-83fa-4ef7-821f-7880f0280421",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "81dd0483-a42b-45d5-9247-8b5ea1e0c0ee",
			"type": "column",
			"content": [
				"05915a54-5c43-4c09-a95c-d14ea9e246f7",
				"962b3529-7c89-4449-aa6c-2cb74f7b49b1"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "f7fb97e9-2b6c-46ca-8a7d-71c93c9a8baa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ac59e5d8-013b-4b80-8686-6a2a26829ce4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0b706069-96ee-4c02-b0f9-fa430ae20a31",
			"type": "column",
			"content": [
				"dc077253-9d61-4bf1-894b-6eb5a548c250"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "111eafdc-a3bc-46fb-a67d-6f92fcbbfc2c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ac59e5d8-013b-4b80-8686-6a2a26829ce4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ed365341-0e50-410a-959e-5aa53279b098",
			"type": "column",
			"content": [
				"63166d22-b05b-48ad-b11e-af1d91677de3"
			],
			"format": {
				"column_ratio": 0.3333333333333334,
				"copied_from_pointer": {
					"id": "d20f2cc9-68c4-4bb3-881f-0c6b155a9387",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ac59e5d8-013b-4b80-8686-6a2a26829ce4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "05915a54-5c43-4c09-a95c-d14ea9e246f7",
			"type": "text",
			"properties": {
				"title": [
					[
						"интернет\nв интернете \nинтернет-магазин"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "7981fb3c-7a55-4930-bbe2-16a55c2f752e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "81dd0483-a42b-45d5-9247-8b5ea1e0c0ee",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "962b3529-7c89-4449-aa6c-2cb74f7b49b1",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "cef767b3-33f3-401b-850e-06a0c3db5ea5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "81dd0483-a42b-45d5-9247-8b5ea1e0c0ee",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dc077253-9d61-4bf1-894b-6eb5a548c250",
			"type": "text",
			"properties": {
				"title": [
					[
						"«интернет» склоняется, со строчной, без кавычек, через дефис  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "0df12fa6-9769-4fd7-80e1-735467b0898f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b706069-96ee-4c02-b0f9-fa430ae20a31",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "63166d22-b05b-48ad-b11e-af1d91677de3",
			"type": "text",
			"properties": {
				"title": [
					[
						"купить в интернет-магазине"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "a5429867-465c-4e9d-bedf-7389cb9e25fa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ed365341-0e50-410a-959e-5aa53279b098",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4ad0f60b-df1e-4ba4-82b7-8e6b4d422553",
			"type": "column",
			"content": [
				"2dc77a03-4517-4d01-8e7a-46dfd3f9e2d9",
				"12f5d391-d9c1-4805-a141-d9711c1a6642"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "3a74340e-212a-491e-8390-2e5fd211a5a9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a5c7fe31-8be5-4a2c-b897-4d964001a7bd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "75bf9ed3-08a5-4d18-9638-0f1a351081f1",
			"type": "column",
			"content": [
				"b1eb613c-1113-4164-bfb8-3385b22f5240"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "105ab4ea-cde5-447b-9808-01b33c0ca914",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a5c7fe31-8be5-4a2c-b897-4d964001a7bd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6af05e46-3107-4fcb-b84f-4e2ee0cde77f",
			"type": "column",
			"content": [
				"16a9f960-d7d9-4b87-80c1-7b8c0ae0f7e9",
				"f625b11a-9da2-408b-a1de-6166361c04db"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "7d9e250e-20a3-41bd-a571-1fba2ae72ec7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a5c7fe31-8be5-4a2c-b897-4d964001a7bd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2dc77a03-4517-4d01-8e7a-46dfd3f9e2d9",
			"type": "text",
			"properties": {
				"title": [
					[
						"корзина "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "d58d2d16-9c34-4abf-b9ad-e1313dcfbc00",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4ad0f60b-df1e-4ba4-82b7-8e6b4d422553",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "12f5d391-d9c1-4805-a141-d9711c1a6642",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "e4b10ff4-33a2-4571-8c1f-bc6054676d12",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4ad0f60b-df1e-4ba4-82b7-8e6b4d422553",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1eb613c-1113-4164-bfb8-3385b22f5240",
			"type": "text",
			"properties": {
				"title": [
					[
						"С родовым словом пишем без кавычек\nс большой буквы, без родового слова — без кавычек со строчной"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "17fce9e3-8005-44c9-8708-52785f63106d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "75bf9ed3-08a5-4d18-9638-0f1a351081f1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "16a9f960-d7d9-4b87-80c1-7b8c0ae0f7e9",
			"type": "text",
			"properties": {
				"title": [
					[
						"файлы в папке "
					],
					[
						"Корзина\n",
						[
							[
								"b"
							]
						]
					],
					[
						"файлы к корзине "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "ef2393f5-2087-4941-90f7-3c4be18c196f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6af05e46-3107-4fcb-b84f-4e2ee0cde77f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f625b11a-9da2-408b-a1de-6166361c04db",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "56bad64f-2182-4a75-a3c1-c409e3c1e979",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6af05e46-3107-4fcb-b84f-4e2ee0cde77f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "47f57646-731f-4dfc-bdc5-622276ade2aa",
			"type": "column",
			"content": [
				"6c9774bc-d418-4254-bd16-aab5b95100c9"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "8e4efec9-1b4a-496d-8699-921a61674334",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fb8383a1-836b-4942-9dd7-bbd9e6aa075b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3afa04c9-cc92-4934-9fef-4e2325762cf5",
			"type": "column",
			"content": [
				"dd254b80-9f34-4510-a8c3-8de5fb3fc3b6"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "e63df3b3-e171-4614-bf5b-e0324145e7af",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fb8383a1-836b-4942-9dd7-bbd9e6aa075b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "246831ee-9759-4684-b4c3-ddb332cf500a",
			"type": "column",
			"content": [
				"7706cdd9-3180-4999-975e-b9b93550118a"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "f973ce0a-6666-4dd7-826f-ab96d793173c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fb8383a1-836b-4942-9dd7-bbd9e6aa075b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6c9774bc-d418-4254-bd16-aab5b95100c9",
			"type": "text",
			"properties": {
				"title": [
					[
						"кэш "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "22f97796-f986-4c08-8e9a-7f7439a5ab2e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "47f57646-731f-4dfc-bdc5-622276ade2aa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd254b80-9f34-4510-a8c3-8de5fb3fc3b6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Через «э»"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "714010ff-4174-425c-8195-861e3ea5a2cd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3afa04c9-cc92-4934-9fef-4e2325762cf5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7706cdd9-3180-4999-975e-b9b93550118a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Почистите кэш "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "9a4333da-4496-4a87-8d75-5a3a2c936a4b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "246831ee-9759-4684-b4c3-ddb332cf500a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "32226d15-0251-4369-99f0-4ef566a5bbaf",
			"type": "column",
			"content": [
				"f93311d9-7e14-459e-a725-e5a9ac591499",
				"cb2f8d05-6000-4448-a014-adbef75ca727"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "a7d6da73-ac19-4412-9d51-b38b4d5e0e6b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "79cb34ad-52fe-46c4-85c4-41805bbc09b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bbc3f4cd-5235-4dd0-8338-94af30251d2d",
			"type": "column",
			"content": [
				"f7548c2c-618c-4501-b691-2f93512b6db5"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "6531a43b-9fce-4b9d-a29f-c1e7ad493aca",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "79cb34ad-52fe-46c4-85c4-41805bbc09b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c8efdfdf-67b7-4b8b-a7f5-5b8c27946a70",
			"type": "column",
			"content": [
				"49dcbb40-2f6d-4c70-a2bd-d13080da2452"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "03ac422d-2275-4f4a-8acb-7413d1fc0c6e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "79cb34ad-52fe-46c4-85c4-41805bbc09b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f93311d9-7e14-459e-a725-e5a9ac591499",
			"type": "text",
			"properties": {
				"title": [
					[
						"кешбэк"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "b3ade053-6a82-4e94-97b1-09b6e4cf80ae",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "32226d15-0251-4369-99f0-4ef566a5bbaf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb2f8d05-6000-4448-a014-adbef75ca727",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "006136a3-766d-4f0d-97d3-b49ca067ae85",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "32226d15-0251-4369-99f0-4ef566a5bbaf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f7548c2c-618c-4501-b691-2f93512b6db5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Первая гласная — «е», вторая гласная — «э»"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "5f0c6ba4-3629-4121-84e3-f1a2a1e4d209",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bbc3f4cd-5235-4dd0-8338-94af30251d2d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "49dcbb40-2f6d-4c70-a2bd-d13080da2452",
			"type": "text",
			"properties": {
				"title": [
					[
						"Двойной кешбэк \nв Чёрную пятницу"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "5aeb9e47-e561-46c7-abff-84dca157834d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c8efdfdf-67b7-4b8b-a7f5-5b8c27946a70",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e8475dea-4452-4d07-909a-ba816d5ffff1",
			"type": "column",
			"content": [
				"a266bdd9-72cc-4a48-8d9d-e2f70bef2465",
				"91ec028f-ba66-48a4-b98f-1b62d27e7d8c"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "dc7413a8-0e87-4829-9390-a48edce98121",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4aa433d4-9fa4-42ca-8326-047a4793e037",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0c5935f-25f2-446d-ba01-3b484ce1b9cf",
			"type": "column",
			"content": [
				"0fb62d7f-f76f-4bb4-8d88-b0fa52c17074"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "ae3891f9-06b3-47d9-93bc-f65d4f4f5934",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4aa433d4-9fa4-42ca-8326-047a4793e037",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "659aae5b-c572-4840-81ec-d541a3de0ac3",
			"type": "column",
			"content": [
				"9813f4bb-9895-442b-a34d-df4014b3dee3"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "cbfc7e38-8ef9-46ab-af06-8895105f3b17",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4aa433d4-9fa4-42ca-8326-047a4793e037",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a266bdd9-72cc-4a48-8d9d-e2f70bef2465",
			"type": "text",
			"properties": {
				"title": [
					[
						"логин"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "95457c30-70f8-4a34-96d8-0a158946d95b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e8475dea-4452-4d07-909a-ba816d5ffff1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91ec028f-ba66-48a4-b98f-1b62d27e7d8c",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "562149bb-43ad-4e87-bc74-bb2c66435896",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e8475dea-4452-4d07-909a-ba816d5ffff1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fb62d7f-f76f-4bb4-8d88-b0fa52c17074",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, \nсо строчной "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "6a86e17b-9ce2-4331-8e70-a576ae6afbb6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a0c5935f-25f2-446d-ba01-3b484ce1b9cf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9813f4bb-9895-442b-a34d-df4014b3dee3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Подтвердите с помощью логина и пароля "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "d256e741-1cbf-4193-8423-9c5056c100f4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "659aae5b-c572-4840-81ec-d541a3de0ac3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a6d2defb-9132-408f-937e-e97763e3ebdd",
			"type": "column",
			"content": [
				"b9f71b58-c463-4e37-adea-43345d809a2e",
				"bb78c9cd-2546-4e65-8951-0a442418c6bf"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "23566c04-de58-49bf-b430-4e27995ad856",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7deceb00-31ab-4bcd-9497-e614c31dadb0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ab2f1ab-63da-43b7-b92f-ab615cb231aa",
			"type": "column",
			"content": [
				"69a3682b-1fec-4a8e-9d31-ec05b0326e1e"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "62347337-7398-4714-bf4f-c7149a2ce391",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7deceb00-31ab-4bcd-9497-e614c31dadb0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52beddca-878e-4f5b-a0fe-adc1b71b8e7b",
			"type": "column",
			"content": [
				"786fe44f-2619-4dcc-8288-3235b3f5e401"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "4d79da83-972b-4299-8c65-991d7c9345a4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7deceb00-31ab-4bcd-9497-e614c31dadb0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b9f71b58-c463-4e37-adea-43345d809a2e",
			"type": "text",
			"properties": {
				"title": [
					[
						"медиапроекты "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "d7058ea2-5183-4698-a54e-ace17ce1adaf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a6d2defb-9132-408f-937e-e97763e3ebdd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bb78c9cd-2546-4e65-8951-0a442418c6bf",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "5fb1d7b1-52ad-4466-9bdf-5532b83e70f8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a6d2defb-9132-408f-937e-e97763e3ebdd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69a3682b-1fec-4a8e-9d31-ec05b0326e1e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Многосоставные слова, где одна часть \n«медиа» — слитно "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "1efe6b86-2c8b-4da5-acd4-4a6807f5736e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0ab2f1ab-63da-43b7-b92f-ab615cb231aa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "786fe44f-2619-4dcc-8288-3235b3f5e401",
			"type": "text",
			"properties": {
				"title": [
					[
						"Медиапроекты Mail"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "822f157c-bbce-49e7-9b81-2f34ef5727b0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "52beddca-878e-4f5b-a0fe-adc1b71b8e7b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "18444cd6-afe8-4430-ac38-dc782cfe9255",
			"type": "column",
			"content": [
				"615715c8-8f7d-4e69-87a7-9a91ae6c0fc7",
				"952a0d64-bb8d-4e36-b3e4-48ed664565b5"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "3a7777cd-ae95-4d4e-aaa1-f7bffd0b5f37",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b84df9e3-1279-4b58-bf0b-c0bdfec55dcb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7498cf2e-07c3-4214-81a1-675120bc6042",
			"type": "column",
			"content": [
				"1ecfffeb-63ae-485f-9982-31b23b81fed5"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "5ad867a5-18b1-4196-8ec5-ae4f56fc9d25",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b84df9e3-1279-4b58-bf0b-c0bdfec55dcb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a5c76adc-44e3-457a-8718-27d769b41e7d",
			"type": "column",
			"content": [
				"59333831-cd62-41d8-bd13-034dc1a28501"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "139a6916-de0e-471e-97ea-f79683c72915",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b84df9e3-1279-4b58-bf0b-c0bdfec55dcb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "615715c8-8f7d-4e69-87a7-9a91ae6c0fc7",
			"type": "text",
			"properties": {
				"title": [
					[
						"онлайн "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "34c9519b-6e9c-4d67-bcfa-a98e8f75be5f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "18444cd6-afe8-4430-ac38-dc782cfe9255",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "952a0d64-bb8d-4e36-b3e4-48ed664565b5",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "43a9b8cd-e626-4746-9c9f-7a3bd0fd7369",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "18444cd6-afe8-4430-ac38-dc782cfe9255",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1ecfffeb-63ae-485f-9982-31b23b81fed5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не склоняется, по-русски, слитно, \nчерез дефис  \nв многосоставном слове"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "c8b2c690-418d-4e89-aee3-51752666c611",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7498cf2e-07c3-4214-81a1-675120bc6042",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "59333831-cd62-41d8-bd13-034dc1a28501",
			"type": "text",
			"properties": {
				"title": [
					[
						"Онлайн-редактирование 15 друзей онлайн "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "82e40a01-37c4-4442-986c-0276723a78b6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a5c76adc-44e3-457a-8718-27d769b41e7d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6cae3bb6-3562-4088-8823-41d1caea57c4",
			"type": "column",
			"content": [
				"afff59db-0bfb-409c-b381-8038303d9f8c",
				"25a4361a-e462-4372-b6f8-463bcc39275a"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "b790503b-e17c-4718-a877-fcac1f24917f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b382a42-b3c7-40b2-95c2-20cb0f21af54",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b6de80ad-3ea0-4132-80a4-e7e8c11c89db",
			"type": "column",
			"content": [
				"7986d543-8b99-44e5-ab74-40e48d14c7ae"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "14506daf-44c4-4ce9-95f1-4ee7554d9cd9",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b382a42-b3c7-40b2-95c2-20cb0f21af54",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "819f879e-1c9f-4e19-8cc6-a112b3712a00",
			"type": "column",
			"content": [
				"1d2c7c7d-de46-4b6f-90ee-472eea7f12b6"
			],
			"format": {
				"column_ratio": 0.3333333333333334,
				"copied_from_pointer": {
					"id": "0c41c581-7124-4742-9e42-02e1acca961b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b382a42-b3c7-40b2-95c2-20cb0f21af54",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "afff59db-0bfb-409c-b381-8038303d9f8c",
			"type": "text",
			"properties": {
				"title": [
					[
						"офлайн "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "71aba1ce-5c4a-450f-9ebc-824b41ada781",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6cae3bb6-3562-4088-8823-41d1caea57c4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "25a4361a-e462-4372-b6f8-463bcc39275a",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "ba0ce822-b5d8-400d-aa4c-cf58179e6e8e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6cae3bb6-3562-4088-8823-41d1caea57c4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7986d543-8b99-44e5-ab74-40e48d14c7ae",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не склоняется, по-русски, слитно, с одной «ф», через дефис  \nв многосоставном слове "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "beb487ed-0946-4dd6-9405-9df78c8519fb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b6de80ad-3ea0-4132-80a4-e7e8c11c89db",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d2c7c7d-de46-4b6f-90ee-472eea7f12b6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Офлайн-доступ \nМария сейчас офлайн"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "4d6bd7db-3f9c-4236-84ef-5c37023fecd1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "819f879e-1c9f-4e19-8cc6-a112b3712a00",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2ddf0398-40f0-4d8b-a02e-45441d625f0b",
			"type": "column",
			"content": [
				"5d7047d4-03d5-42df-a5d3-848becea8c24",
				"cb4033d2-6260-49c1-8ba1-241625a0dba9"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "b94c7b3f-7673-4f81-9f50-08192e9bb513",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8657965d-8ac2-4a1b-8591-8835bf15ef15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a6cfd558-98f2-422f-a759-781d026a135c",
			"type": "column",
			"content": [
				"35d897ae-bbfa-4482-b384-b2da6d7a6c56"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "4e49390d-c086-4824-982e-667526e68d8f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8657965d-8ac2-4a1b-8591-8835bf15ef15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "24de6356-9c48-4bf8-b721-1e07aa87fd3c",
			"type": "column",
			"content": [
				"83d31790-8b65-48c0-b8e8-5c56d5ab7eaa"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "00f7dffb-ffdb-4c15-8321-19396f1f9dd1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8657965d-8ac2-4a1b-8591-8835bf15ef15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5d7047d4-03d5-42df-a5d3-848becea8c24",
			"type": "text",
			"properties": {
				"title": [
					[
						"промокод \nпромоакция  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "65d1a4d5-9398-40a6-84ec-a85c6185347d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2ddf0398-40f0-4d8b-a02e-45441d625f0b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb4033d2-6260-49c1-8ba1-241625a0dba9",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "a71796f9-246b-478f-8a32-b70aa0d5abec",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2ddf0398-40f0-4d8b-a02e-45441d625f0b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35d897ae-bbfa-4482-b384-b2da6d7a6c56",
			"type": "text",
			"properties": {
				"title": [
					[
						"Многосоставные слова, где одна часть \n«промо» —  слитно "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "f2d5c2ee-f5d6-447a-98a7-fb4f90538fa5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a6cfd558-98f2-422f-a759-781d026a135c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83d31790-8b65-48c0-b8e8-5c56d5ab7eaa",
			"type": "text",
			"properties": {
				"title": [
					[
						"Промоакция от Облака "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "9c9036c4-1500-4c58-842f-0d9fdd7df993",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "24de6356-9c48-4bf8-b721-1e07aa87fd3c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "854d838e-aeaf-4489-938c-192cf7cd6b69",
			"type": "column",
			"content": [
				"6f5a9e4a-872e-4432-9ee7-ce08e933acc5",
				"6cdf8550-b1ed-4195-a26b-57a005615e78"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "158dc380-8d20-4ca6-b510-39ef803c2149",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4802c2b9-6e7e-44bd-b633-9d0b38a34dcd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa3d30b6-88e5-4430-a162-6137d54960b1",
			"type": "column",
			"content": [
				"e789defa-cb3d-4990-8967-23dd6fe914b1"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "2f20aa29-8f1c-42fb-ab4e-59a9a1dcd3de",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4802c2b9-6e7e-44bd-b633-9d0b38a34dcd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd4945e4-638b-4eab-8e3d-54e7d54054f9",
			"type": "column",
			"content": [
				"3bf74387-339d-43d2-9b97-38afe7dc1d87",
				"ad448fc0-77fa-4669-a90b-ff198600d90b"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "b2554fd6-4c42-4ec6-975a-3f4773a71f33",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4802c2b9-6e7e-44bd-b633-9d0b38a34dcd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6f5a9e4a-872e-4432-9ee7-ce08e933acc5",
			"type": "text",
			"properties": {
				"title": [
					[
						"пуш\nпуш-уведомление  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "89189a8e-eb27-4b15-b601-9ecf688194da",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "854d838e-aeaf-4489-938c-192cf7cd6b69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6cdf8550-b1ed-4195-a26b-57a005615e78",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "705f794e-dc09-4db7-abf8-6170169c39e7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "854d838e-aeaf-4489-938c-192cf7cd6b69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e789defa-cb3d-4990-8967-23dd6fe914b1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Можно и так, и так. \nПо-русски, прописными, через дефис"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "7290eb13-1c21-4c89-baee-a413037e4adf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fa3d30b6-88e5-4430-a162-6137d54960b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3bf74387-339d-43d2-9b97-38afe7dc1d87",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пришлём пуш"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "19bc81a0-89a0-4b53-986a-068cd8aa7a2e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bd4945e4-638b-4eab-8e3d-54e7d54054f9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad448fc0-77fa-4669-a90b-ff198600d90b",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "dc2b3a36-7778-45b0-ab6c-f244d99993a0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "bd4945e4-638b-4eab-8e3d-54e7d54054f9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "890ed4b1-52cd-42e4-870c-08f87f28daa1",
			"type": "column",
			"content": [
				"52b994b8-c206-40a8-8f0a-c93794c637be",
				"5c5f3385-0fc5-4ad0-a76b-880bc399e0b3"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "f14a20cd-b824-4152-aed4-4d582401b56d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "441f6c5b-0ffb-48d1-a3f5-f29fc2e9b446",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0e477402-4c49-417c-b9f4-2512a2b7a277",
			"type": "column",
			"content": [
				"b716f69b-0921-4d86-975e-37d932bdfd88"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "75888959-622f-49ef-9a55-06bb0c22dab1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "441f6c5b-0ffb-48d1-a3f5-f29fc2e9b446",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a32cd4d-32c8-4c52-8256-ffc0b4d18a4f",
			"type": "column",
			"content": [
				"483d6220-d698-4730-8912-2bf602262b17"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "3d9365be-d8ce-4321-93cb-fdf5ee22d86f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "441f6c5b-0ffb-48d1-a3f5-f29fc2e9b446",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52b994b8-c206-40a8-8f0a-c93794c637be",
			"type": "text",
			"properties": {
				"title": [
					[
						"СМС\nСМС-уведомления  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "1ec9c19b-dd39-4601-98a0-8ba604a7c566",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "890ed4b1-52cd-42e4-870c-08f87f28daa1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5c5f3385-0fc5-4ad0-a76b-880bc399e0b3",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "6124798e-a944-4366-a4fe-f6d549cd0323",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "890ed4b1-52cd-42e4-870c-08f87f28daa1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b716f69b-0921-4d86-975e-37d932bdfd88",
			"type": "text",
			"properties": {
				"title": [
					[
						"Можно и так, и так. \nПо-русски, заглавными, через дефис   "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "e73ad377-5b59-4309-a7f8-2fd8128958e0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0e477402-4c49-417c-b9f4-2512a2b7a277",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "483d6220-d698-4730-8912-2bf602262b17",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пришлём СМС Подпишитесь на СМС-уведомления "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "ba271d98-3009-406b-af91-c0ec4d3f76d3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8a32cd4d-32c8-4c52-8256-ffc0b4d18a4f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7579c963-b4c9-466b-8135-4290dd0faf29",
			"type": "column",
			"content": [
				"e92bc8be-1d43-4aae-ac79-e177985a07fd",
				"dc86ebd8-f333-403d-a362-ce81dca6f2df"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "e624307f-2b5e-4776-8e57-2d3bb8f03c5e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0fa7d2dd-16e5-40a1-9f9c-9bf283d34d3d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "89c48907-45cf-48d9-b967-ce08b5c538ce",
			"type": "column",
			"content": [
				"7eac913d-ac29-45b7-be2c-9a5668108e07"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "ca0041b0-2a88-4563-b13f-6fd11c7fe6b4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0fa7d2dd-16e5-40a1-9f9c-9bf283d34d3d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0152a23f-ca0f-4ceb-8821-a027f47de299",
			"type": "column",
			"content": [
				"1d5d7ecd-0611-4663-8da9-05e7b3621fde"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "94936cf4-e167-44f6-b16f-1105997bb74f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0fa7d2dd-16e5-40a1-9f9c-9bf283d34d3d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e92bc8be-1d43-4aae-ac79-e177985a07fd",
			"type": "text",
			"properties": {
				"title": [
					[
						"соцсети  "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "d294055b-b615-4857-80f8-04d673d6192f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7579c963-b4c9-466b-8135-4290dd0faf29",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dc86ebd8-f333-403d-a362-ce81dca6f2df",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "9b336323-702d-4914-908d-a845b31b857a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7579c963-b4c9-466b-8135-4290dd0faf29",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7eac913d-ac29-45b7-be2c-9a5668108e07",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, слитно. \nНо «Соц. сети», если это сокращенное написание папки «Социальные сети»"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "52c6a03d-e08e-45f2-a3f3-f91d075171e6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "89c48907-45cf-48d9-b967-ce08b5c538ce",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d5d7ecd-0611-4663-8da9-05e7b3621fde",
			"type": "text",
			"properties": {
				"title": [
					[
						"Подписывайтесь \nна наши соцсети "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "b7c3d99c-b99b-4397-9219-29b93bb4475c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0152a23f-ca0f-4ceb-8821-a027f47de299",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f293570-631f-4961-852a-9a41af601519",
			"type": "column",
			"content": [
				"6def8942-4bfc-43be-9da5-bddd38ec727f",
				"8bbb43fa-6719-411b-9558-875ee94d4aac"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "568bc351-b6fd-450f-9593-d49d094b26f2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0338648d-0c18-4886-a119-9c2920771ac6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1eb2cb9a-fb5a-46af-ab89-67f6b56a77af",
			"type": "column",
			"content": [
				"971b69e1-dba3-4eac-af8c-25cb71d3a07e"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "ba9874c4-929d-4702-a7b0-cba637f1182e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0338648d-0c18-4886-a119-9c2920771ac6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b9371174-da35-448f-9b50-fdfd4496fca5",
			"type": "column",
			"content": [
				"3187baad-93b3-4cf8-99ad-275afee7e655"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "0da8c149-8663-4c51-8132-b01c4dff2a1a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0338648d-0c18-4886-a119-9c2920771ac6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6def8942-4bfc-43be-9da5-bddd38ec727f",
			"type": "text",
			"properties": {
				"title": [
					[
						"скриншот   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "66b6c0b9-7b86-4082-a1e8-b7a31efb52cf",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9f293570-631f-4961-852a-9a41af601519",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8bbb43fa-6719-411b-9558-875ee94d4aac",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "f4916461-645a-4d84-babb-ca0602a31511",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9f293570-631f-4961-852a-9a41af601519",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "971b69e1-dba3-4eac-af8c-25cb71d3a07e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, слитно "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "4e3eede8-f6b9-474b-b191-33470ed68c91",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1eb2cb9a-fb5a-46af-ab89-67f6b56a77af",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3187baad-93b3-4cf8-99ad-275afee7e655",
			"type": "text",
			"properties": {
				"title": [
					[
						"Поделитесь скриншотом "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "20352453-6778-4b71-a3e8-c960ce780187",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b9371174-da35-448f-9b50-fdfd4496fca5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9fbe86a2-917f-4230-9898-faf6e5d24e4e",
			"type": "column",
			"content": [
				"aee36aad-2f8a-413c-9123-7b448eb9e7ff",
				"dcee8714-f613-400c-97b2-69c4e92ab3c9"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "35cd7f49-fd53-489f-ad6d-51628a6f9527",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e1a42aef-241a-4926-ac36-80b6916e400c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "53ca77ec-7b56-48ec-b28a-e345ccc45729",
			"type": "column",
			"content": [
				"d06d9207-0849-440b-9094-28de2923601d"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "6cd48000-47df-4002-96b2-c2a7471fc21c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e1a42aef-241a-4926-ac36-80b6916e400c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "01398d3c-f1cd-4b83-9ac3-2da4da029e0c",
			"type": "column",
			"content": [
				"91627099-a148-4014-82c5-acc24a661a2f",
				"03631928-2a76-4294-9890-443d5cfea3c7"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "36f3fae0-230c-470f-a657-447ca5ee0088",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e1a42aef-241a-4926-ac36-80b6916e400c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aee36aad-2f8a-413c-9123-7b448eb9e7ff",
			"type": "text",
			"properties": {
				"title": [
					[
						"спам\nспам-фильтры   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "917dc912-6263-4b59-aeaf-5c171d169f3b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9fbe86a2-917f-4230-9898-faf6e5d24e4e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dcee8714-f613-400c-97b2-69c4e92ab3c9",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "9bbc24fd-2182-4f0b-bc1d-58e5eac8f888",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9fbe86a2-917f-4230-9898-faf6e5d24e4e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d06d9207-0849-440b-9094-28de2923601d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Через дефис, \nодиночное — склоняется, \nсоставное — нет   "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "75443668-efd7-4f42-85f0-d862f1b97848",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "53ca77ec-7b56-48ec-b28a-e345ccc45729",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91627099-a148-4014-82c5-acc24a661a2f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Можно настроить спам-фильтры "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "31612a1a-aab7-413b-8a9a-3862dd8e1cc0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "01398d3c-f1cd-4b83-9ac3-2da4da029e0c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "03631928-2a76-4294-9890-443d5cfea3c7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Удалить вместе \nсо спамом"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a7a92f13-1512-49fa-a6f0-b35e7777f0eb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "01398d3c-f1cd-4b83-9ac3-2da4da029e0c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "847ea0b3-ce94-4d38-888f-2f45736dbae2",
			"type": "column",
			"content": [
				"300a9570-16f8-4a92-9079-bcd3b1520a23",
				"54ae6480-8e84-421d-aeb9-3bb9d541273f"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "9441f63f-9343-4dac-bc0e-aa9752cdae75",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3a8a108d-2042-4ca9-ae3f-0bdb2a8c9632",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cad8f0da-2c36-4142-84c0-1b73d01bdf2a",
			"type": "column",
			"content": [
				"464ba87f-b41b-448b-b31e-09806c6d30ce"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "9bd3934d-094f-462e-8219-53e6016d2e28",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3a8a108d-2042-4ca9-ae3f-0bdb2a8c9632",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1a83b137-76b6-4aea-a473-397f34446b03",
			"type": "column",
			"content": [
				"44340795-6a31-47e3-a55b-3794f833b5e1"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "fca9a17c-eacd-4913-8e59-b2cf57680d7a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3a8a108d-2042-4ca9-ae3f-0bdb2a8c9632",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "300a9570-16f8-4a92-9079-bcd3b1520a23",
			"type": "text",
			"properties": {
				"title": [
					[
						"техподдержка   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "233c3654-7fce-448f-9642-20d6720e84c6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "847ea0b3-ce94-4d38-888f-2f45736dbae2",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "54ae6480-8e84-421d-aeb9-3bb9d541273f",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "598494d9-fc7d-4783-b2e7-4e0566a29abe",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "847ea0b3-ce94-4d38-888f-2f45736dbae2",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "464ba87f-b41b-448b-b31e-09806c6d30ce",
			"type": "text",
			"properties": {
				"title": [
					[
						"Склоняется, слитно    "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "b5df7623-176a-4da0-bde0-83e11e2a55aa",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cad8f0da-2c36-4142-84c0-1b73d01bdf2a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "44340795-6a31-47e3-a55b-3794f833b5e1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Как обратиться \nв техподдержку "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "7845a2ec-787b-4216-bbce-99007a655119",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1a83b137-76b6-4aea-a473-397f34446b03",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "940b38d1-6e28-47ba-8c49-303f4786f81a",
			"type": "column",
			"content": [
				"3ff6a825-bb4c-4f69-9e3b-da5649149f10",
				"8f1ff197-88e5-4f27-be13-5ae1531b53d3"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "6e7e5bc2-d467-47fb-9f4c-e26013e52ea4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91f4ba84-312e-4c73-a0a7-daf8b39a530c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a3a472e9-2415-4c35-ab23-1896b97e0076",
			"type": "column",
			"content": [
				"76edc769-35e9-4c61-93e6-2367ef5fa8eb"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "c704f5e3-c337-4993-900a-15cca2d23389",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91f4ba84-312e-4c73-a0a7-daf8b39a530c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "32922db6-17b7-446c-bb66-6fb205afd011",
			"type": "column",
			"content": [
				"4bfc7576-91c0-4450-aa7b-99b7c727533b"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "94e97ab3-02e0-44fc-9426-84aad06e11dc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91f4ba84-312e-4c73-a0a7-daf8b39a530c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3ff6a825-bb4c-4f69-9e3b-da5649149f10",
			"type": "text",
			"properties": {
				"title": [
					[
						"куки\nкуки-файлы   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "868cd6d3-88d2-46e1-b6d2-cbac18b769ec",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "940b38d1-6e28-47ba-8c49-303f4786f81a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8f1ff197-88e5-4f27-be13-5ae1531b53d3",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "14682995-b02f-428c-a01c-596e5ff87f4d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "940b38d1-6e28-47ba-8c49-303f4786f81a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "76edc769-35e9-4c61-93e6-2367ef5fa8eb",
			"type": "text",
			"properties": {
				"title": [
					[
						"По русски, не склоняется, через дефис, со строчной     "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "73ed56e6-a89d-422a-851c-399dc436ab86",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a3a472e9-2415-4c35-ab23-1896b97e0076",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4bfc7576-91c0-4450-aa7b-99b7c727533b",
			"type": "text",
			"properties": {
				"title": [
					[
						"На сайте работают куки "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "7a797cf8-e8fc-41fd-8e5a-c94a855df576",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "32922db6-17b7-446c-bb66-6fb205afd011",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "91711d1c-bc38-4260-86f4-c6d432d1d994",
			"type": "column",
			"content": [
				"bc6b1b8a-9201-4138-89fd-556f65c49aee",
				"ba5c2d27-e05f-4cc6-8ce1-ca7c61c6e048"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "bfc26a9c-ec1d-4d7b-9aec-aa6a6549790e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd2901dd-ef5f-4a9f-858b-a5dd3b6af21d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4834414c-9342-4c95-b20d-cc36fea0a98b",
			"type": "column",
			"content": [
				"3583c18e-1d2d-4907-9b8a-92f7b4b18815"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "f85ac7bd-c483-45a1-a191-a522bdd55c3b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd2901dd-ef5f-4a9f-858b-a5dd3b6af21d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1de7394c-0b94-41cb-b209-6476cdd4dfcf",
			"type": "column",
			"content": [
				"31af3a7f-a877-490e-8df4-7dd09ee01b1e"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "25e9b7ac-d403-4f2f-9fae-20208f500085",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cd2901dd-ef5f-4a9f-858b-a5dd3b6af21d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bc6b1b8a-9201-4138-89fd-556f65c49aee",
			"type": "text",
			"properties": {
				"title": [
					[
						"email   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "2ccfe62a-33d6-43dd-aae8-120d419ea09e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91711d1c-bc38-4260-86f4-c6d432d1d994",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba5c2d27-e05f-4cc6-8ce1-ca7c61c6e048",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "146ca699-fdbc-4f03-9b57-6251d08f5eeb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "91711d1c-bc38-4260-86f4-c6d432d1d994",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3583c18e-1d2d-4907-9b8a-92f7b4b18815",
			"type": "text",
			"properties": {
				"title": [
					[
						"Слитно, со строчной     "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "4a2f4bdd-37de-425b-8cbc-fb14979e7744",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "4834414c-9342-4c95-b20d-cc36fea0a98b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "31af3a7f-a877-490e-8df4-7dd09ee01b1e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Проверьте email-рассылки "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "7e46b51a-0aa2-4939-a936-e7c05e0e61cd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1de7394c-0b94-41cb-b209-6476cdd4dfcf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ca61e0c3-0003-465f-ae02-3b0b8e02850c",
			"type": "column",
			"content": [
				"e1d65e1e-4a53-41df-afff-ca102c22bece",
				"23203725-e319-4442-861f-eee6a7fad049"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "3892cad9-b82d-4910-83e8-b2d6fefa6bd6",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "194f2e10-2038-4c9e-a670-34608cb4521f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b8158a7f-d864-4bf2-8746-4bcb494e85e5",
			"type": "column",
			"content": [
				"acf13fe6-5659-4693-8ccb-57433b689675"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "b0665f64-38f9-45c9-ac18-be9dee44b89e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "194f2e10-2038-4c9e-a670-34608cb4521f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2cd31ab5-c44c-4909-9e37-c8a4e0848650",
			"type": "column",
			"content": [
				"59ef440a-6529-4243-855e-fe277c95a4ec"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "569a358f-a0b0-46bb-acef-168d37998a92",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "194f2e10-2038-4c9e-a670-34608cb4521f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e1d65e1e-4a53-41df-afff-ca102c22bece",
			"type": "text",
			"properties": {
				"title": [
					[
						"ПИН-код   "
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "fbeba733-5267-4349-a8dc-bd7ee22eb081",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ca61e0c3-0003-465f-ae02-3b0b8e02850c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "23203725-e319-4442-861f-eee6a7fad049",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "bb47f04d-0d71-4e81-8e2d-2bfd1744dd4d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ca61e0c3-0003-465f-ae02-3b0b8e02850c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "acf13fe6-5659-4693-8ccb-57433b689675",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заглавными, \nна латинице, через дефис"
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "ff5f74c7-3969-42bb-a82f-335fcb13419c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b8158a7f-d864-4bf2-8746-4bcb494e85e5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "59ef440a-6529-4243-855e-fe277c95a4ec",
			"type": "text",
			"properties": {
				"title": [
					[
						"Придумайте новый ПИН-код"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "7ce9483a-464c-4ba6-a6d0-9f0a477a2f38",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "2cd31ab5-c44c-4909-9e37-c8a4e0848650",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1c6dc1b0-9985-4909-9b7b-4f37a9edc126",
			"type": "column",
			"content": [
				"00573309-72a5-444a-b724-7811f19082ba",
				"ccc0e990-d549-4d75-b975-4cd751f8b5ac"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "1947b03f-18f4-4b73-b754-d2dfed3d5fd5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b4ea0d9-7914-4042-91f2-28c4dcae6065",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9e87e868-d5de-4d86-bd5e-3f20c242238f",
			"type": "column",
			"content": [
				"9bd872f7-799d-42a6-858f-1e145ee00b33"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "25d94f62-9c55-43ac-a4b2-834a9c7c9562",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b4ea0d9-7914-4042-91f2-28c4dcae6065",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ecf0c966-3848-4f5a-801b-2e0876c8de6c",
			"type": "column",
			"content": [
				"5b0dfcb5-a6a4-40f8-a14d-7aad1c4ee9a9"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "dd957142-76c9-4c05-adad-f0f3fae1d84d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0b4ea0d9-7914-4042-91f2-28c4dcae6065",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "00573309-72a5-444a-b724-7811f19082ba",
			"type": "text",
			"properties": {
				"title": [
					[
						"Face ID"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "71a96ba6-7713-47c2-8ead-0d247079afcb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1c6dc1b0-9985-4909-9b7b-4f37a9edc126",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ccc0e990-d549-4d75-b975-4cd751f8b5ac",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "8936515e-f5bd-44de-84ba-01c8b649a156",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1c6dc1b0-9985-4909-9b7b-4f37a9edc126",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9bd872f7-799d-42a6-858f-1e145ee00b33",
			"type": "text",
			"properties": {
				"title": [
					[
						"На латинице, \nвсегда с заглавной "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "a3d4de2d-5468-4ea9-a67d-ad395c727c1b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9e87e868-d5de-4d86-bd5e-3f20c242238f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5b0dfcb5-a6a4-40f8-a14d-7aad1c4ee9a9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Вход через Face ID "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "7bb02420-b1d4-44ff-97a9-9591cd95b3ac",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ecf0c966-3848-4f5a-801b-2e0876c8de6c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b4a0a141-5b43-4308-8526-4338ea4322fd",
			"type": "column",
			"content": [
				"c8178e9b-6a1c-473a-bc8c-d6272ca1b0f8",
				"cabc12cd-3590-496b-8558-a0c59fd968ec"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "198e756b-6161-4608-9135-cc997b4bd591",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d28d759b-9a09-46f0-a99a-09ebbc16cc36",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ab74831f-73f2-48a8-a423-6d7a8bcccc84",
			"type": "column",
			"content": [
				"a7d736ca-71d1-47a2-97f5-e6ac2313f83b"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "1e2a6cc0-4cc0-4a3f-8aae-8cbdbe30fa76",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d28d759b-9a09-46f0-a99a-09ebbc16cc36",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9547280c-f60c-4188-8437-b005f78aaff0",
			"type": "column",
			"content": [
				"f689b6c2-d605-4c83-9f54-9c37640d8e96"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "880ce79b-1af4-4f87-924a-bdf8a24b21ac",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d28d759b-9a09-46f0-a99a-09ebbc16cc36",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c8178e9b-6a1c-473a-bc8c-d6272ca1b0f8",
			"type": "text",
			"properties": {
				"title": [
					[
						"QR-код"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "1bc9b99d-893b-4614-8af5-3717f176814b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b4a0a141-5b43-4308-8526-4338ea4322fd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cabc12cd-3590-496b-8558-a0c59fd968ec",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "e158b439-d947-4636-aadc-770240dddfc0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b4a0a141-5b43-4308-8526-4338ea4322fd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7d736ca-71d1-47a2-97f5-e6ac2313f83b",
			"type": "text",
			"properties": {
				"title": [
					[
						"На латинице, \nвсегда с заглавной, через дефис  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "69da8fb4-8f9b-491d-a591-5142aa9d5afb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ab74831f-73f2-48a8-a423-6d7a8bcccc84",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f689b6c2-d605-4c83-9f54-9c37640d8e96",
			"type": "text",
			"properties": {
				"title": [
					[
						"Отсканируйте QR-код "
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "4a89bffb-7bf2-4a0c-bc87-11cac101df80",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9547280c-f60c-4188-8437-b005f78aaff0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d67186ce-3fa0-4c06-95f9-f42717da022e",
			"type": "column",
			"content": [
				"93301964-141d-4657-b633-f2cbbcae4cd7",
				"f9f1ee67-e9bf-40f9-8c6f-dac9755b6740"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "50be42f5-63f8-449f-b12c-0c7d12d5dd79",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f2599c1-1d73-4346-9b52-a92251376654",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "03c341e4-d1de-472c-9d0c-c36447b73faf",
			"type": "column",
			"content": [
				"e2515d3b-7ac9-484d-b002-760350943e3a"
			],
			"format": {
				"column_ratio": 0.3333333333333333,
				"copied_from_pointer": {
					"id": "28441cde-5147-497c-a728-62f16660fcd7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f2599c1-1d73-4346-9b52-a92251376654",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "498dd8c2-f0a6-4649-aa2e-dabefa06ac0d",
			"type": "column",
			"content": [
				"690137ad-b2da-4819-9b40-3fc3c12f29c8"
			],
			"format": {
				"column_ratio": 0.33333333333333337,
				"copied_from_pointer": {
					"id": "63400bba-3334-46bf-bfe9-e97208727df1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f2599c1-1d73-4346-9b52-a92251376654",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93301964-141d-4657-b633-f2cbbcae4cd7",
			"type": "text",
			"properties": {
				"title": [
					[
						"VK ID"
					]
				]
			},
			"format": {
				"page_icon": "👍🏽",
				"copied_from_pointer": {
					"id": "18843702-e277-4959-94c6-e20a5884d71e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d67186ce-3fa0-4c06-95f9-f42717da022e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9f1ee67-e9bf-40f9-8c6f-dac9755b6740",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "3ab60b96-7d7e-4c7f-a48c-4e9360fd2b92",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d67186ce-3fa0-4c06-95f9-f42717da022e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e2515d3b-7ac9-484d-b002-760350943e3a",
			"type": "text",
			"properties": {
				"title": [
					[
						"На латинице, \nвсе буквы — заглавные \n  "
					]
				]
			},
			"format": {
				"page_icon": "✅",
				"copied_from_pointer": {
					"id": "0ac27af0-d88e-4860-acf6-c475eeebf5c2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "03c341e4-d1de-472c-9d0c-c36447b73faf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "690137ad-b2da-4819-9b40-3fc3c12f29c8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Войдите с помощью \nVK ID"
					]
				]
			},
			"format": {
				"page_icon": "📝",
				"copied_from_pointer": {
					"id": "73818fdc-6301-46fb-845f-9437796ffd59",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "498dd8c2-f0a6-4649-aa2e-dabefa06ac0d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Названия проектов Mail",
			"id": "ae7fca1b-8057-4ad9-b1b0-855daeb2fee5"
		},
		{
			"title": "Аккаунт vs ящик",
			"id": "e2e95227-c787-4424-a005-e775cf25a212"
		},
		{
			"title": "Спорные слова ",
			"id": "b7934229-1ac1-4480-a2a5-176588133f35"
		}
	]
}} />
);

export default NotionVoiceAndToneGlossary;
